import './imageSourceForm.scss';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { browserHistory } from 'react-router';
import classnames from 'classnames';
import sourceTypes from '../../../js/imageSourceTypes';
import { isUndefinedNullOrEmpty, hasValue } from '../../../js/utils';
import { connect } from 'react-redux';
import { setSource } from '../../../js/actions/imagingWorkflowActionCreators';
import BackupBlue from '../../../icons/clone-icons_backup-blue.svg';
import BackupGray from '../../../icons/clone-icons_backup-gray.svg';
import LiveBlue from '../../../icons/clone-icons_server-instance-blue.svg';
import LiveGray from '../../../icons/clone-icons_server-instance-gray.svg';
import BackLink from '../../common/BackLink';

const validate = (values) => {
    const errors = {};

    if (isUndefinedNullOrEmpty(values.sourcetype)) {
        errors.sourcetype = 'Select an image location';
    }

    if (!hasValue(sourceTypes, values.sourcetype)) {
        errors.sourcetype = 'Invalid input';
    }

    return errors;
};

const SourceTypeSelect = React.createClass({
    getInitialState: function () {
        return {
            sourceType: sourceTypes.backup
        };
    },
    selectBackupSource: function () {
        this.setState({ sourceType: sourceTypes.backup });
        this.handleChange(sourceTypes.backup);
    },
    selectSqlServerSource: function () {
        this.setState({ sourceType: sourceTypes.sqlServer });
        this.handleChange(sourceTypes.sqlServer);
    },
    handleChange: function (value) {
        this.props.input.onChange(value);
    },
    render: function () {
        const { input, meta: { touched, error } } = this.props;
        const sourceType = input.value;
        const isBackupSelected = sourceType === sourceTypes.backup;
        const isSqlServerSelected = sourceType === sourceTypes.sqlServer;
        const backupSourceClasses = classnames('sourceBackup', 'pure-u-1-2', { 'selected': isBackupSelected });
        const sqlServerSourceClasses = classnames('sourceServer', 'pure-u-1-2', { 'selected': isSqlServerSelected });

        return (
            <div className="image-source-form">
                <h4 className="pure-u-1">Source Type</h4>
        
                <div className={backupSourceClasses} onClick={this.selectBackupSource}>
                    <input type="radio" name="sourceType" value={sourceTypes.backup} autoFocus
                        onChange={this.handleChange} checked={input.value === sourceTypes.backup}/>
                    <img src={isBackupSelected ? BackupBlue : BackupGray}></img>
                    <p>Backup</p>
                </div>
                <div className={sqlServerSourceClasses} onClick={this.selectSqlServerSource}>
                    <input type="radio" name="sourceType" value={sourceTypes.sqlServer} 
                        onChange={this.handleChange} checked={input.value === sourceTypes.sqlServer}/>
                    <img src={isSqlServerSelected ? LiveBlue : LiveGray}></img>
                    <p>SQL Server</p>
                </div>
                <div className="pure-u-1 source-type-explanation">
                {isBackupSelected && <span>
                    This can be a SQL Server (.bak) or SQL Backup (.sqb).<br />
                    We will use this backup file and temporarily restore it using a compatible SQL Server instance.<br />
                    We recommend using backups for creating images from a production environment.
                </span>}
                {isSqlServerSelected && <span>
                    This can be an existing database on SQL Server 2008 or above.<br />
                    Ideal for development and test systems.
                </span>}
                </div>
            </div>
        );
    }
});

const ImageSourceForm = React.createClass({
    render: function () {
        const { handleSubmit, pristine, reset, submitting, onFormValid, valid } = this.props;
        const goToNext = (data) => {
            onFormValid(data);
            browserHistory.push('/images/create/source');
        };

        return <form onSubmit={handleSubmit(goToNext)}>
            <div>
                <div className="form-container">
                    <BackLink invisible />
                    <h1>Create a new image</h1>
                    <div className="sourceTypes pure-g">
                        <Field name="sourcetype" component={SourceTypeSelect} />
                    </div>
                    <div className="pure-g">
                        {valid && //Default selection is valid - so don't check for pristine!
                            <button type="submit" className="button button--primary" disabled={submitting}>
                                Next
                            </button>}
                    </div>
                </div>
            </div>
        </form>;
    }
});


const mapStateToProps = (state) => {
    return {
        imageCreation: state.app.imageCreation,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onFormValid(data) {
            dispatch(setSource(data.sourcetype));
        }
    };
};

const component = connect(mapStateToProps, mapDispatchToProps)(ImageSourceForm);

export default reduxForm({
    form: 'ImageSource',
    validate
})(component);



// WEBPACK FOOTER //
// ./src/components/imaging/ImageSourcePage/imageSourceForm.jsx